import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Hoy',
    [filter_yesterday]: 'Ayer',
    [filter_this_week]: 'Esta semana',
    [filter_last_week]: 'Semana pasada',
    [filter_this_month]: 'Este mes',
    [filter_last_month]: 'Mes pasado',
    [filter_last_30_days]: 'Últimos 30 días',
    [filter_all]: 'Todos',
  },
};
